/* eslint-disable */
import { ServicesTypeService } from '@/store/services-type/services-type-service'
import Message from '@/shared/message/toastify'
import Errors from '@/shared/error/errors'
import { i18n } from '@/locales/i18n'
import router from '@/router'
import { FileUploader } from '@/shared/uploader/file-uploader'

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null
  },

  getters: {
    record: state => state.record,
    findLoading: state => !!state.findLoading,
    saveLoading: state => !!state.saveLoading
  },

  mutations: {
    RESET(state) {
      state.findLoading = false
      state.saveLoading = false
      state.record = null
    },

    FIND_STARTED(state) {
      state.record = null
      state.findLoading = true
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload
      state.findLoading = false
    },

    FIND_ERROR(state) {
      state.record = null
      state.findLoading = false
    },

    ADD_STARTED(state) {
      state.saveLoading = true
    },

    ADD_SUCCESS(state) {
      state.saveLoading = false
    },

    ADD_ERROR(state) {
      state.saveLoading = false
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false
    }
  },

  actions: {
    doNew({ commit }) {
      commit('RESET')
    },

    async doFind({ commit }, id) {
      try {
        commit('FIND_STARTED')
        const record = await ServicesTypeService.find(id)
        commit('FIND_SUCCESS', record)
      } catch (error) {
        Errors.handle(error)
        commit('FIND_ERROR')
        router.push('/servicesType')
      }
    },

    async doCreate({ commit }, values) {
      try {
        commit('ADD_STARTED')
        await ServicesTypeService.create(values)
        commit('ADD_SUCCESS')
        Message.success(i18n('servicesType.create.success'))
        router.push('/servicesType')
      } catch (error) {
        Errors.handle(error)
        commit('ADD_ERROR')
      }
    },
    async doUpdate({ commit }, { id, values }) {
      try {
        commit('UPDATE_STARTED')
        await ServicesTypeService.update(id, values)
        commit('UPDATE_SUCCESS')
        Message.success(i18n('servicesType.update.success'))
        router.push('/servicesType')
      } catch (error) {
        Errors.handle(error)
        commit('UPDATE_ERROR')
      }
    },
  }
}
